import { render, staticRenderFns } from "./SMSServiceTest.vue?vue&type=template&id=16707ff4"
import script from "./SMSServiceTest.vue?vue&type=script&lang=js"
export * from "./SMSServiceTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports